// ////////////////////////////スマホ/タブレット判別
var _ua = (function (u) {
  return {
    Tablet: (u.indexOf('windows') != -1 && u.indexOf('touch') != -1) ||
      u.indexOf('ipad') != -1 ||
      (u.indexOf('android') != -1 && u.indexOf('mobile') == -1) ||
      (u.indexOf('firefox') != -1 && u.indexOf('tablet') != -1) ||
      u.indexOf('kindle') != -1 ||
      u.indexOf('silk') != -1 ||
      u.indexOf('playbook') != -1,
    Mobile: (u.indexOf('windows') != -1 && u.indexOf('phone') != -1) ||
      u.indexOf('iphone') != -1 ||
      u.indexOf('ipod') != -1 ||
      (u.indexOf('android') != -1 && u.indexOf('mobile') != -1) ||
      (u.indexOf('firefox') != -1 && u.indexOf('mobile') != -1) ||
      u.indexOf('blackberry') != -1
  };
})(window.navigator.userAgent.toLowerCase());
// if(_ua.Mobile){}

var osVer;
osVer = 'Android';

var ua = navigator.userAgent.toLowerCase();
var iPadFlag = false;
if (/android|ipod|ipad|iphone|macintosh/.test(ua) && 'ontouchend' in document) {
  iPadFlag = true;
}
// if (navigator.userAgent.indexOf(osVer)>0){
// }

var breakNum = 768;
var tabletNum = 1024;
// ////////////////////////////////////init
$(function () {
  setScroll();
  if ($('#wrapper').hasClass('home')) {
  }
// ///////////
// if (!_ua.Mobile && !_ua.Tablet) {
//   $('#wrapper').addClass('desktop')
//   if (!$('#wrapper').hasClass('about')) {
//     $('html, body').prop({
//       scrollTop: 0
//     })
//     if (ua.indexOf('safari') !== -1 && ua.indexOf('chrome') === -1 && ua.indexOf('edge') === -1) {
//       // ここにSafari用の記述
//     }else {
//       setLuxy()
//     }
//   }
// }
// ///////////
});

$(window).on('load', function () {
  // heightLineGroup()
  judgeWinSize();
  setLoaded();
  setWay();
  if ($('#wrapper').hasClass('archive')) {
    setAcc();
    setCarousel01();
    optCheck();
    showAll();
    showDetail();
  }
  if ($('#wrapper').hasClass('contact')) {
    setForm();
  }
  // setSpan()
  // setMainMenu()
  // setHeader()
  if (!_ua.Mobile && !_ua.Tablet) {
  }
});

// //////////////////////////フォーム制御
function setForm () {
  // URLのアンカー（#以降の部分）を取得
  // var urlHash = location.hash
  // if (urlHash) {
  //   if (urlHash == '#reserve') {
  //     $('select[name=subject-type]').val('事前導入相談会について')
  //   }else if (urlHash == '#order') {
  //     $('select[name=subject-type]').val('有料お申し込みについて')
  //   }
  // }
  if ($('.formHead').length) {
    $('.formHead').insertBefore('.secInput');
  }

  $('.wpcf7-tel').attr('pattern', '\\d*');
  $('.wpcf7-tel').attr('onkeyup', 'if(event.keyCode==9||event.keyCode==16) return; this.value=this.value.replace(/[^0-9]+/i,"")');

  $('#confirmBtn').on('click', function () {
    $('.wpcf7c-btn-confirm').click();
  });
  $('#backBtn').on('click', function () {
    $('.wpcf7c-btn-back').click();
  });
  $('#submitBtn').on('click', function () {
    $('.wpcf7-submit').click();
  });

  $('#press textarea').keypress(function () {
    $('.submitCol .sep').addClass('disp');
  });

  // /////エラーのとき
  document.addEventListener('wpcf7invalid', function (event) {
    setTimeout(function () {
      var position = $('.wpcf7-not-valid-tip:first').offset().top - 300;
      $('html,body').animate({
        scrollTop: position
      }, {
        queue: false
      });
    }, 100);
  }, false);
  // /////成功のとき
  document.addEventListener('wpcf7mailsent', function (event) {
    $('html,body').animate({
      scrollTop: 0
    }, {
      queue: false
    });
  }, false);
}

// ///////////////////////////フォーム確認画面
function setConfirm () {
  var myEst = $('.selectedDetail h2').text();
  $('[name=myest]').val(myEst);

  var myType = $('.selectedDetail p>span:first-child').text();
  $('[name=mytype]').val(myType);

  var tx = $('[name=myname]').val();
  $('#nameTx').text(tx);

  var tx = $('[name=mymail]').val();
  $('#mailTx').text(tx);

  var tx = $('[name=mytel]').val();
  $('#telTx').text(tx);

  var tx = $('[name=subject]').val();
  $('#subjectTx').text(tx);

  var tx = $('[name=content]').val();
  $('#contentTx').text(tx);
}

// 全て見る
function showAll () {
  $('.btnAll p').on('click', function () {
    $(this).parents('.estListWrap').addClass('active');
    $(this).parents('.estListWrap').find('section:nth-child(n+6)').slideDown('fast');
    var pos = $(this).parents('.estListWrap').find('section:nth-child(6)').offset().top;
    $('html, body').animate(
      {
        scrollTop: pos
      },
      800,
      'swing'
    );
  });
}

// もっと読む
function showDetail () {
  var lineNum = 4; // 表示する行数
  setDetail();
  function setDetail () {
    $('.summary p').each(function () {
      var textHeight = $(this).height();
      var lineHeight = parseFloat($(this).css('line-height')); // line-height
      var textNewHeight = lineHeight * lineNum; // 指定した行数までのテキストの高さ
      if (textHeight > textNewHeight) {
        $(this).parent().find('.toDetail').removeClass('hide');
        $(this).addClass('active');
        // 続きを読むボタンクリックで全文表示
        $(this).parent().find('.toDetail p').click(function () {
          $(this).parent().addClass('hide');
          $(this).parents('.summary').find('p').removeClass('active');
        });
      }else {
        $(this).parent().find('.toDetail').addClass('hide');
        $(this).removeClass('active');
      }
    });
  }

  var timer = false;
  var currentWidth = window.innerWidth;
  window.addEventListener('resize', function () {
    if (currentWidth == window.innerWidth) {
      return;
    }
    currentWidth = window.innerWidth;
    if (timer !== false) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      setDetail();
    }, 200);
  });
}

// 同意チェック
function optCheck () {
  $('.optCheck').on('click', function () {
    $('.optCheck').toggleClass('active');
    $('.cnvBtn').toggleClass('deactive');
  });
}

// 画像拡縮
// function setZoomer () {
//   $('.zoomerStyle_01').zoomer({
//     controls: {
//       position: 'right'
//     },
//     marginMin: 20, // Min bounds
//     marginMax: 100, // Max bounds
//   })
// }

// カルーセル
function setCarousel01 () {
  var target = '.carouselStyle_01';
  $(target).each(function () {
    var slider = $(this).find('.screen');
    var slideCount = $(this).find('.screen>.carouselItem').length;
    var baseCount = slideCount + 1;
    if (baseCount > 0) {
      slider.slick({
        // initialSlide: randomStart,
        dots: true,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 8000,
        arrows: true,
        // fade: true,
        speed: 500,
        pauseOnFocus: false,
        pauseOnHover: false,
        pauseOnDotsHover: false,
      // cssEase: 'cubic-bezier(.645, .045, .355, 1)'
      });
    }
    slider.on('touchmove', function (event, slick, currentSlide, nextSlide) {
      slider.slick('slickPlay');
    });

  // var timer = false
  // var currentWidth = window.innerWidth
  // window.addEventListener('resize', function () {
  //   if (currentWidth == window.innerWidth) {
  //     return
  //   }
  //   currentWidth = window.innerWidth
  //   if (timer !== false) {
  //     clearTimeout(timer)
  //   }
  //   timer = setTimeout(function () {
  //     slider.slick('slickPlay')
  //   }, 200)
  // })
  });
}

function setCarousel02 (target) {
  var target = target;
  target.each(function () {
    var slider = $(this).find('.screen');
    var slideCount = $(this).find('.screen>.carouselItem').length;
    var baseCount = slideCount + 1;
    if (baseCount > 0) {
      slider.slick({
        // initialSlide: randomStart,
        dots: true,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 8000,
        arrows: true,
        // fade: true,
        speed: 500,
        pauseOnFocus: false,
        pauseOnHover: false,
        pauseOnDotsHover: false,
      // cssEase: 'cubic-bezier(.645, .045, .355, 1)'
      });
    }
    slider.on('touchmove', function (event, slick, currentSlide, nextSlide) {
      slider.slick('slickPlay');
    });

  // var timer = false
  // var currentWidth = window.innerWidth
  // window.addEventListener('resize', function () {
  //   if (currentWidth == window.innerWidth) {
  //     return
  //   }
  //   currentWidth = window.innerWidth
  //   if (timer !== false) {
  //     clearTimeout(timer)
  //   }
  //   timer = setTimeout(function () {
  //     slider.slick('slickPlay')
  //   }, 200)
  // })
  });
}
// テキストアニメーション用span生成
function setSpan () {
  $('.txEffect>span').each(function () {
    var text = $.trim(this.textContent),
      html = '';

    text.split('').forEach(function (v) {
      html += '<span>' + v + '</span>';
    });

    this.innerHTML = html;
  });
}

// ///////waypoint
function setWay () {
  $('.way,.alphaWay,.js-way').waypoint(
    function (direction) {
      var activePoint = $(this.element);
      if (direction === 'down') {
        // scroll down
        activePoint.addClass('is-active');
        timer = setTimeout(function () {
          activePoint.addClass('activeAfter');
        }, 1000);
      }
    },
    {
      offset: '70%'
    }
  );
}

// ////////////////////////////アコーディオン
function setAcc () {
  $('.estItem .headInfo').on('click', function () {
    $(this).toggleClass('active');
    $(this).next().stop().slideToggle();
    var targetSlide = $(this).parent().find('.carouselStyle_02');
    if (!$(this).hasClass('start')) {
      setCarousel02(targetSlide);
      $(this).addClass('start');
    }
    $(this).next().find('.zoomerStyle_01').zoomer({
      controls: {
        position: 'right'
      },
      marginMin: 20, // Min bounds
      marginMax: 100, // Max bounds
    });

    if ($(this).hasClass('active')) {
      var pos = $(this).offset().top;
      $('html, body').animate(
        {
          scrollTop: pos
        },
        800,
        'swing'
      );
    }
  });
}

// ////////////ウィンドウサイズを判別
function judgeWinSize () {
  var winW = $(window).width();
  if (winW > breakNum) {
    $('#wrapper').addClass('setPc');
  } else {
    $('#wrapper').addClass('setSp');
  }

  var timer = false;
  var currentWidth = window.innerWidth;
  window.addEventListener('resize', function () {
    if (currentWidth == window.innerWidth) {
      return;
    }
    currentWidth = window.innerWidth;
    if (timer !== false) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      winW = $(window).width();
      if (winW > breakNum) {
        $('#wrapper').addClass('setPc');
        $('#wrapper').removeClass('setSp');
      } else {
        $('#wrapper').addClass('setSp');
        $('#wrapper').removeClass('setPc');
      }
    }, 200);
  });
}

// //////////////////////////////ロード完了
function setLoaded () {
  $('#loading').addClass('loaded');
  $('#wrapper').addClass('loaded');
  if ($('#wrapper').hasClass('home')) {
    loadStart();
  }else {
    $('#wrapper').addClass('loadedDone');
    $('#wrapper').addClass('loadEnd');
  }
}

function loadStart () {
  timer = setTimeout(function () {
    $('#wrapper').addClass('loadedDone');
  }, 400);
  timer = setTimeout(function () {
    $('#wrapper').addClass('loadEnd');
  }, 1500);
// $('body,html').animate({
//   scrollTop: 0
// }, 0, 'swing')
}

// function setGnav () {
//   var i = 0
//   setInterval(function () {
//     $('#headNav li').eq(i).addClass('start')
//     i++
//     if (i >= $('#headNav li').length) i = 0
//   }, 100)
// }

// /////////////////////////////スムーススクロール
function setScroll () {
  // var headerHight = $('header').height() + 40
  var headerHight = $('header').height();
  $('a[href^="#"]').click(function (e) {
    var href = $(this).attr('href');
    var target = $(href == '#' || href == '' ? 'html' : href);
    var position = target.offset().top - headerHight;

    if ($(this).hasClass('unqNav')) {
      closeFnc();
    }
    $.when(
      $('html, body').animate(
        {
          scrollTop: position
        },
        400,
        'swing'
      ),
      e.preventDefault()
    ).done(function () {
      var diff = target.offset().top - headerHight;
      if (diff === position) {
      } else {
        $('html, body').animate(
          {
            scrollTop: diff
          },
          10,
          'swing'
        );
      }
    });
  });
}

function startScroll () {
  // var headerHight = 0
  if ($('#wrapper').hasClass('setPc')) {
    var headerHight = 0;
  }else {
    var headerHight = $('header').height();
  }
  var href = $(location).attr('hash');
  if (href) {
    $('#wrapper').addClass('setUnq');
    timer = setTimeout(function () {
      var target = $(href == '#' || href == '' ? 'html' : href);
      var position = target.offset().top - headerHight;
      $.when(
        $('html, body').animate(
          {
            scrollTop: position
          },
          400,
          'swing'
        )
      ).done(function () {
        var diff = target.offset().top - headerHight;
        if (diff === position) {
        } else {
          $('html, body').animate(
            {
              scrollTop: diff
            },
            10,
            'swing'
          );
        }
        if ($('#wrapper').hasClass('setPc')) {
          $('#wrapper').removeClass('setUnq');
        }
      });
    }, 1000);
  }else {
  }
}

// ////////////////////////////////////ランドスケープ判定
var isLandscape = function () {
  if (window.innerHeight > window.innerWidth) {
    jQuery('body').addClass('portrait');
    jQuery('body').removeClass('landscape');
  } else {
    jQuery('body').addClass('landscape');
    jQuery('body').removeClass('portrait');
  }
};

if (_ua.Mobile) {
  jQuery(window).resize(function () {
    isLandscape();
  });
  isLandscape();
}

// //////////////////////////////高さ揃え
function heightLineGroup () {
  // setAutoHeight('#photoDiary .articleStyle_02 .inner')
  var winW = $(window).width();
  if (winW > breakNum) {
    // setAutoHeight('.setH_01 h2', 4)
    // setAutoHeight('.setH_01 h2')
    // setAutoHeight('#photoDiary .articleStyle_02 .inner')
    // setAutoHeight(".setH_01 .summary",3)
  } else {
    setAutoHeight('.setH_01 h2', 2);
    setAutoHeight('.setH_02 h2', 2);
  // setAutoHeight("#setH_08 h2",2)
  }

  startResize();
}

function setAutoHeight (target, count) {
  $(target).tile(count);
}

function startResize () {
  var timer = false;
  var currentWidth = window.innerWidth;
  window.addEventListener('resize', function () {
    if (currentWidth == window.innerWidth) {
      return;
    }
    currentWidth = window.innerWidth;
    if (timer !== false) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      heightLineGroup();
    }, 200);
  });
}
